import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import RMAList from './RMAList';
import RMADetailsView from './RMADetailsView';
import RMAReviewSystem from './RMAReviewSystem';

const ServicemanRMAReview = ({ userType = 'serviceman' }) => {
  const [currentView, setCurrentView] = useState('list');
  const [selectedRMAId, setSelectedRMAId] = useState(null);
  const [mode, setMode] = useState('view');
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleSelectRMA = (rmaId, actionMode = 'view') => {
    setSelectedRMAId(rmaId);
    setMode(actionMode);
    if (actionMode === 'view') {
      setCurrentView('details');
    } else {
      setCurrentView('edit');
    }
  };

  const handleBackToList = () => {
    setCurrentView('list');
    setSelectedRMAId(null);
    setMode('view');
    setRefreshTrigger(prev => prev + 1); // Trigger refresh on back
  };

  const handleEdit = () => {
    setMode('edit');
    setCurrentView('edit');
  };

  const handleDownload = () => {
    console.log('Downloading RMA:', selectedRMAId);
  };

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
    console.log('Refreshing RMA list');
  };

  return (
    <Box sx={{ p: 2 }}>
      {currentView === 'list' && (
        <RMAList
          onSelectRMA={handleSelectRMA}
          onRefresh={handleRefresh}
          refreshTrigger={refreshTrigger}
          userType={userType} // Pass userType to RMAList
        />
      )}

      {currentView === 'details' && (
        <RMADetailsView
          rmaId={selectedRMAId}
          onBack={handleBackToList}
          onEdit={handleEdit}
          onDownload={handleDownload}
          userType={userType}
        />
      )}

      {currentView === 'edit' && (
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <Button
              variant="outlined"
              startIcon={<ArrowBack />}
              onClick={handleBackToList}
            >
              Back to List
            </Button>
            <Typography variant="h6">
              Edit RMA
            </Typography>
          </Box>
          <RMAReviewSystem
            rmaId={selectedRMAId}
            onBack={handleBackToList}
            userType={userType} // Pass userType
          />
        </Box>
      )}
    </Box>
  );
};

export default ServicemanRMAReview;